/**
 * StatBox Component
 * Displays labelled statistics with status indication
 */

import React from 'react';

interface StatBoxProps {
  label: string;
  value: string | number;
  unit?: string;
  status?: 'neutral' | 'active' | 'warning';
}

export const StatBox: React.FC<StatBoxProps> = ({
  label,
  value,
  unit,
  status = 'neutral',
}) => {
  const labelClass =
    status === 'warning'
      ? 'text-amber-600'
      : 'text-gray-400 group-hover:text-[#007a6d]';

  const valueClass =
    status === 'active'
      ? 'text-[#007a6d]'
      : status === 'warning'
        ? 'text-amber-600'
        : 'text-gray-900';

  return (
    <div className="flex flex-col group" role="status" aria-label={`${label}: ${value}${unit || ''}`}>
      <span
        className={`text-[8px] sm:text-[9px] font-black uppercase tracking-widest transition-colors ${labelClass}`}
      >
        {label}
      </span>
      <span className={`text-lg sm:text-xl font-black tabular-nums transition-all ${valueClass}`}>
        {value}
        {unit && (
          <span className="text-[9px] sm:text-[10px] ml-0.5 sm:ml-1 text-gray-400 uppercase font-bold">
            {unit}
          </span>
        )}
      </span>
    </div>
  );
};
